<template>
    <v-autocomplete class="m-1"
                    v-model="input"
                    :items="siteTypes"
                    dense
                    :rules="rules"
                    item-text="keyAlias"
                    item-value="key"
                    :error-messages="errors !== undefined ? errors.site_type : []"
                    label="نوع سایت مورد نظر خود را انتخاب کنید."
                    outlined
                    :return-object="return_object"
    ></v-autocomplete>
</template>

<script>

export default {
    props: ['value', 'errors', 'dense', 'return_object'],

    data() {
        return {
            input: null,
            rules: [
                (value) => !!value || "وارد کردن این فیلد الزامی است.",
            ],
            siteTypes: [
                {key: 'personal', keyAlias: 'سایت شخصی'},
                {key: 'corporative', keyAlias: 'سایت شرکتی'},
                {key: 'shop', keyAlias: 'سایت فروشکاهی'},
                {key: 'charity', keyAlias: 'سایت موسسه خیریه'},
                {key: 'news', keyAlias: 'سایت خبری'},
                {key: 'download', keyAlias: 'سایت دانلود'},
            ],

        }
    },
    name: "siteSelect",
    created() {
        this.input = this.value
    },
    watch: {
        input() {
            this.$emit('input', this.input)
        }
    }
}
</script>

<style scoped>

</style>